import { styled } from "@mui/material/styles";

export const EmptyEstimatedQuoteWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  padding: "40px 24px 80px",
}))

export const EmptyEstimatedQuoteImage = styled("img")(() => ({
  width: 250,
  marginBottom: "10px",
}))

export const EmptyEstimatedQuoteTitle = styled("h2")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "2rem",
  lineHeight: "40px",
  color: "#1D2939",
}))

export const EmptyEstimatedQuoteText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "1.375rem",
  lineHeight: "28px",
  color: "#465869",
}))
